import { Component, ElementRef, EventEmitter, HostListener, Input, OnChanges, OnDestroy, OnInit, Output, ViewChild, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { FormControl, FormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';
import { MainBodyService } from 'src/app/services/main-body.service';
import { JournalType } from 'src/interface/book';
import { journalResponse, themeData } from 'src/interface/themesetting';
import { JournalService } from '../../journal.service';
import { GetArticlesService } from 'src/app/services/get-articles.service';
import { ActivatedRoute } from '@angular/router';
import { listArticle } from 'src/interface/article';

@Component({
    selector: 'app-article-search',
    templateUrl: './article-search.component.html',
    styleUrls: ['./article-search.component.scss']
})
export class ArticleSearchComponent implements OnInit, OnDestroy, OnChanges {
    @ViewChild('selectJournal') selectElement: ElementRef;
    public searchForm: FormGroup;
    searchData: { searchValue: FormControl; journalSelect: FormControl };
    @Input() searchLoader: boolean;
    valueForSearch: string;
    @Output() searchEmit = new EventEmitter<string>();
    @Output() searchClick = new EventEmitter<boolean>();
    @Output() clearSearchClick = new EventEmitter<boolean>();
    @Output() journalEmit = new EventEmitter<string>();
    @Input() journalid: string;
    @Input() selectDiv: boolean;
    @Input() valueSearched: string;
    themeSettingsData: themeData;
    journalSubscription: Subscription[] = [];
    journalData: string[] = []
    @Output() searchListLoader = new EventEmitter<boolean>;
    @Input() searchedArticles: listArticle[] = [];
    constructor(private mainBodyService: MainBodyService,
        private journalService: JournalService,
        private articleService: GetArticlesService,
        private route: ActivatedRoute, 
        @Inject(PLATFORM_ID) private platformId: any) { }

    ngOnInit(): void {
        const routeSub = this.route.queryParams.subscribe(params => {
            this.valueSearched = params['search'] != undefined ? params['search'] : '';

            this.searchForm = new FormGroup({
                searchValue: new FormControl(this.valueSearched),
                journalSelect: new FormControl('All')
            })
            this.searchData = {
                searchValue: this.searchForm.get('searchValue') as FormControl,
                journalSelect: this.searchForm.get('journalSelect') as FormControl

            };
        });
        this.journalSubscription.push(routeSub);

        if (this.journalid) {
            this.mainBodyService.getAllThemeSettings(this.journalid).subscribe((result) => {
                if (result.status === 200) {
                    this.themeSettingsData = result.data;
                    if (isPlatformBrowser(this.platformId)) {
                        Object.entries(this.themeSettingsData.theme_colors).map(([key, value]) => {
                            const element = "--" + key;
                            const val = value;
                            document.documentElement.style.setProperty(element, val);
                        });
                    }
                }
            });
        }

        const journalType: JournalType = { jnl_type: "" }
        const subjournaltype = this.journalService.getJournals(journalType).subscribe((result: journalResponse) => {
            this.journalData.push('All');
            result.data.forEach(eachItem => {
                this.journalData.push(eachItem.id);
            })
        })
        this.journalSubscription.push(subjournaltype);
    }

    @HostListener('document:keydown.enter', ['$event']) onKeydownHandler() { //event: KeyboardEvent
        this.searchClick.emit(true);
    }


    searchArticle() {
        this.valueForSearch = this.searchForm.get('searchValue')?.value ?? '';
        // The parent decides when a request is actually in flight and drives [searchLoader].
        this.searchEmit.emit(this.valueForSearch);
        this.searchListLoader.emit(this.valueForSearch.length > 0);
    }

    showSearchedArticle() {
        this.searchLoader = false;
        this.searchClick.emit(true);
    }

    clearSearch() {
        this.searchLoader = false;
        this.articleService.clearSearch = true;
        this.searchForm.get('searchValue')?.setValue('');
        this.searchForm.get('journalSelect')?.setValue('All');
        this.clearSearchClick.emit(true);
    }

    // getJournalSelected() {
    //     this.journalEmit.emit(this.searchForm.get('journalSelect')?.value);
    // }

    ngOnDestroy() {
        this.journalSubscription.forEach(x => {
            if (!x.closed) {
                x.unsubscribe();
            }
        });
    }
    ngOnChanges() {
        if (this.searchedArticles.length > 0) {
            this.searchLoader = false;
        }
    }
}
